export default "__VITE_PUBLIC_ASSET__80b7700b__"